import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { FoundationRoot } from '@renderer/app/layout/foundation-root';
import { ContractEditorScreen } from '@renderer/domains/contracts/contract-editor-screen';
import { ContractTemplateEditorScreen } from '@renderer/domains/contracts/contract-template-editor-screen';
import { ContractTemplatesScreen } from '@renderer/domains/contracts/contract-templates-screen';
import { ContractsScreen } from '@renderer/domains/contracts/contracts-screen';
import { CustomerEditorScreen } from '@renderer/domains/customers/customer-editor-screen';
import { CustomersScreen } from '@renderer/domains/customers/customers-screen';
import { DashboardScreen } from '@renderer/domains/dashboard/dashboard-screen';
import { InvoiceEditorScreen } from '@renderer/domains/invoices/invoice-editor-screen';
import { InvoicesScreen } from '@renderer/domains/invoices/invoices-screen';
import { LeadEditorScreen } from '@renderer/domains/leads/lead-editor-screen';
import { LeadsScreen } from '@renderer/domains/leads/leads-screen';
import { PaymentEditorScreen } from '@renderer/domains/payments/payment-editor-screen';
import { PaymentsScreen } from '@renderer/domains/payments/payments-screen';
import { ProjectEditorScreen } from '@renderer/domains/projects/project-editor-screen';
import { ProjectsScreen } from '@renderer/domains/projects/projects-screen';
import { AssetEditorScreen } from '@renderer/domains/resources/asset-editor-screen';
import { ResourcesScreen } from '@renderer/domains/resources/resources-screen';
import { AviScreen } from '@renderer/domains/avi/avi-screen';
import { DomainPlaceholderScreen } from '@renderer/domains/shared/domain-placeholder-screen';
import { SettingsScreen } from '@renderer/domains/settings/settings-screen';
import { TasksScreen } from '@renderer/domains/tasks/tasks-screen';

export function buildAppRoutes(): RouteObject[] {
  return [
    {
      path: '/',
      element: <FoundationRoot />,
      children: [
        {
          index: true,
          element: <Navigate replace to="/dashboard" />
        },
        {
          path: 'dashboard',
          element: <DashboardScreen />
        },
        {
          path: 'projects',
          element: <ProjectsScreen />
        },
        {
          path: 'projects/:projectId',
          element: <ProjectEditorScreen />
        },
        {
          path: 'leads',
          element: <LeadsScreen />
        },
        {
          path: 'leads/:leadId',
          element: <LeadEditorScreen />
        },
        {
          path: 'tasks',
          element: <TasksScreen />
        },
        {
          path: 'customers',
          element: <CustomersScreen />
        },
        {
          path: 'customers/:customerId',
          element: <CustomerEditorScreen />
        },
        {
          path: 'resources',
          element: <ResourcesScreen />
        },
        {
          path: 'resources/:assetId',
          element: <AssetEditorScreen />
        },
        {
          path: 'contracts',
          element: <ContractsScreen />
        },
        {
          path: 'contracts/templates',
          element: <ContractTemplatesScreen />
        },
        {
          path: 'contracts/templates/:templateId',
          element: <ContractTemplateEditorScreen />
        },
        {
          path: 'contracts/:contractId',
          element: <ContractEditorScreen />
        },
        {
          path: 'invoices',
          element: <InvoicesScreen />
        },
        {
          path: 'invoices/:invoiceId',
          element: <InvoiceEditorScreen />
        },
        {
          path: 'payments',
          element: <PaymentsScreen />
        },
        {
          path: 'payments/:paymentOrderId',
          element: <PaymentEditorScreen />
        },
        {
          path: 'settings',
          element: <SettingsScreen />
        },
        {
          path: 'settings/company-profiles',
          element: <SettingsScreen />
        },
        {
          path: 'settings/customer-types',
          element: <SettingsScreen />
        },
        {
          path: 'settings/payments',
          element: <SettingsScreen />
        },
        {
          path: 'avi',
          element: <AviScreen />
        },
        {
          path: 'help',
          element: <DomainPlaceholderScreen labelKey="navigation.help" />
        },
        {
          path: '*',
          element: <Navigate replace to="/dashboard" />
        }
      ]
    }
  ];
}
